import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';
import { JobFlowResponse } from '@data-terminal/shared-models/job-flow';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class JobFlowApiService {
    readonly #http = inject(HttpClient);
    readonly #url = `${inject(BACKEND_URL)}${inject(ORGANIZATION_REQUEST_PREFIX)}jobFlow`;

    getJobFlow(jobId: string): Observable<JobFlowResponse> {
        return this.#http.get<JobFlowResponse>(`${this.#url}/${encodeURIComponent(jobId)}`);
    }
}
